import { IFrame } from '@r-and-a-shared-ui/common-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';

export default {
  component: () => IFrame,
  mapEntryToProps: (entry: PLAYER_PORTALS_MODELS.IFrame) =>
    kontentAiDataMapping.iframe(entry),
};
